import { render, staticRenderFns } from "./SecuserEdit.vue?vue&type=template&id=2f0bcffa"
import script from "./SecuserEdit.vue?vue&type=script&lang=js"
export * from "./SecuserEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports